import React from 'react'
import styles from './styles.module.css'

export default function() {
  return (
    <h3 className={styles.title}>
      {`Cost Burdened Households by Income as a Percentage of Area Median income (AMI)`}
    </h3>
  )
}
